import { Link } from "react-router-dom";

import { Button } from "src/components/buttons";

interface WrappedLinkProps {
  readonly targetRoute: string;
  readonly children: React.ReactNode;
  readonly className?: string;
  readonly name: string;
  readonly newTab?: boolean;
}

const WrappedLink = ({
  targetRoute,
  children,
  className,
  name,
  newTab
}: WrappedLinkProps) => {
  return (
    <Link
      key={name}
      to={targetRoute}
      title={`${window.location.protocol}//${window.location.host}${targetRoute}`}
      target={newTab ? "_blank" : "_self"}
    >
      <Button name={name} kind="tertiary" className={className || ""}>
        {children}
      </Button>
    </Link>
  );
};

export { WrappedLink as Link };
